import axios from "axios";
import { SERVER_URL } from "config";

const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 1000000,
});

export const postContactUsApi = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/unwind-street`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
